<template>
  <div id="notice-details">
    <div class="notice-details">
      <section>
        <h1><p style="text-align: center"> {{ releaseNotes.version }}版本主要更新</p></h1>
        <div class="article">
          <div v-html="releaseNotes.context"></div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import {releaseNotesDetail} from "@/api/releaseNotes"
export default {
  name: 'releaseNotesDetail',
  components: { },
  props: ['id'],
  data() {
    return {
      releaseNotes: ""
    }
  },
  computed: {},
  created() {
    this.detail();
  },
  methods: {
    detail() {
      releaseNotesDetail(this.$route.params.id)
          .then((res) => {
            this.releaseNotes = res.releaseNotes;
          })
          .catch((e) => {
            this.loading = false;
          });
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/theme/theme";
.notice-details {
  padding: 12px 15px 0;

  section {
    padding: 15px;
    margin-bottom: 12px;
    box-sizing: border-box;
    border-radius: 6px;
    background: #fff;
  }

  section:nth-child(1) {
    h1 {
      margin-bottom: 20px;
      line-height: 24px;
      @extend .font18;
    }
    .article {
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>

<style lang="scss">
.article {
  h1, h2, h3, h4, h5, h6, p ,strong{
    font-weight: revert;
  }
}
</style>